import { get } from "micro-dash";
import mediaPlaceholder from "../../../assets/media_placeholder.svg";
import styles from "./Block.module.scss";
import React from "react";
import { PhotoBackground } from "./PhotoBackground";

export const SinglePhoto = ({
    block,
    alternativePlaceholderImage,
    showBlockPhotoUploadModal,
    allowPhotoUpload = true,
}) => (
    <div className="tile is-12 is-parent">
        <div className="tile is-child">
            <PhotoBackground
                url={get(block, ["photos", "0", "fileName"], mediaPlaceholder)}
                extraClassName={styles.isSingle}
                mediaPlaceholder={mediaPlaceholder}
                alternativePlaceholderImage={alternativePlaceholderImage}
                showBlockPhotoUploadModal={() =>
                    showBlockPhotoUploadModal(block.id)
                }
                allowPhotoUpload={allowPhotoUpload}
            />
        </div>
    </div>
);
